/**
 * @example `await asyncTimeout(1000);`
 * @param ms - Duration of stTimeout in Milliseconds.
 * @returns Promise, which must be awaited for timeout to occur.
 */
export async function asyncTimeout(ms: number): Promise<void> {
    return new Promise((resolve) => setTimeout(resolve, ms));
}
